import PropTypes from 'prop-types';
import { Box, Stack, Typography } from '@mui/material';

import { RESULT_PAGE_TYPES } from 'constants/components';
import { useHeaderHeight } from 'hooks/useHeaderHeight';
import PageContainer from 'layouts/PageContainer';

const getBannerBgColor = (palette, type) => {
  let backgroundColor;
  let borderColor;

  switch (type) {
    case RESULT_PAGE_TYPES.SUCCESS:
      backgroundColor = palette.colors.statusGreen;
      borderColor = palette.colors.statusGreen;
      break;
    case RESULT_PAGE_TYPES.ERROR:
      backgroundColor = palette.colors.statusRed;
      borderColor = palette.colors.statusRed;
      break;
    default:
      backgroundColor = palette.colors.lightPale;
      borderColor = palette.colors.darkPale;
  }

  return { borderColor, backgroundColor };
};

const styles = {
  container: ({ breakpoints }, headerHeight) => ({
    height: '100%',
    minHeight: '100vh',
    paddingTop: `${headerHeight + 28}px`,
    paddingInline: 3,
    paddingBottom: 3,
    [breakpoints.up('md')]: {
      paddingTop: `${headerHeight + 110}px`,
    },
  }),
  banner: ({ palette, breakpoints }, type) => ({
    ...getBannerBgColor(palette, type),
    paddingInline: 1,
    paddingBlock: 2,
    borderRadius: '20px',
    borderWidth: '2px',
    borderStyle: 'solid',
    [breakpoints.up('md')]: {
      paddingInline: 4,
      paddingBlock: 6,
    },
  }),
};

const ResultPage = ({ title = '', message, type = RESULT_PAGE_TYPES.ERROR, content = null }) => {
  const { headerHeight } = useHeaderHeight();

  return (
    <PageContainer sx={(theme) => styles.container(theme, headerHeight)}>
      <Stack spacing={{ xs: 4.5, md: 8 }}>
        <Typography variant="h1">{title}</Typography>

        <Box sx={(theme) => styles.banner(theme, type)}>
          <Typography
            variant="h2-bold"
            component="p"
            color={type === RESULT_PAGE_TYPES.MESSAGE ? 'text.primary' : 'text.secondary'}
          >
            {message}
          </Typography>
        </Box>

        {content}
      </Stack>
    </PageContainer>
  );
};

ResultPage.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string.isRequired,
  type: PropTypes.oneOf(Object.values(RESULT_PAGE_TYPES)),
  content: PropTypes.node,
};
export default ResultPage;
